import Vue from 'vue';
import {
  required, email, regex,
} from 'vee-validate/dist/rules';
import { extend, ValidationProvider } from 'vee-validate';

extend('required', {
  ...required,
  message: '{_field_} is required',
});

extend('email', {
  ...email,
  message: 'Email must be valid',
});

extend('regex', {
  ...regex,
  message: 'This field must be a valid ',
});

// eslint-disable-next-line prefer-object-spread
extend('noEuroEmail',
  {
    message: 'Email addresses with EU domains are not accepted',
    validate: value => !((/^[a-zA-Z0-9_.+-]+@(?:(?:[a-zA-Z0-9-]+\.)?[a-zA-Z]+\.)?(ac|ax|al|ad|at|by|xn--90ais|\u0411\u0415\u041b|be|ba|bg|hr|cy|cz|dk|ee|eu|fo|fi|fr|de|gi|gr|gg|va|hu|is|ie|im|it|je|lv|li|lt|lu|mk|xn--d1alf|\u041c\u041a\u0414|mt|md|mc|me|nl|no|pl|pt|ro|ru|su|xn--p1ai|\u0420\u0424|sm|rs|xn--90a3ac|\u0421\u0420\u0411|sk|si|es|sj|se|ch|ua|xn--j1amh|\u0423\u041a\u0420|gb|uk)$/gi).test(value.trim())),
  });

Vue.component('ValidationProvider', ValidationProvider);

Vue.directive('remove-aria-required', {
  inserted(el) {
    removeAriaRequired(el);
  },
  update(el) {
    removeAriaRequired(el);
    setRequired(el);
  },
  bind(el) {
    setRequired(el);
  },
});

function removeAriaRequired(el) {
  if (el.hasAttribute('aria-required')) {
    el.removeAttribute('aria-required');
  }
  // Recursively apply to child elements
  if (el.children) {
    Array.from(el.children).forEach(child => removeAriaRequired(child));
  }
}

function setRequired(el) {
  if (isFormControl(el)){
    el.setAttribute('required', 'true');
  }
  // Recursively apply to child elements
  if (el.children) {
    Array.from(el.children).forEach(child => setRequired(child));
  }
}

function isFormControl(el) {
  return ['INPUT', 'SELECT', 'TEXTAREA'].includes(el.tagName);
}